import React from 'react';
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import '../../assets/landingPageCss/privacy.css';
import Footer from './Footer';
import Navbar from './Navbar';
import {Link} from 'react-router-dom';

function Terms() {
  document.title = 'Adcropper | Terms';
  return (
    <main className='untitled-page mainContent'>
      <Navbar />
      <section className="privacySection">
        <div class="privacyWrapper">
          <h1 class="privacyTitle">Terms of Service</h1>
        </div>
      </section>
      {/* Privacy Text */}
      <section class="privacyTextSection">
        <div class="privacyTextWrapper">
          <p class="privacyText">These Terms Of Use constitute a legally binding agreement between you, whether personally
            or on behalf of a legal entity and company. </p>
          <p class="privacyText">Please carefully read these terms and conditions. If you do not agree with these terms,
            you should not use the website and our digital product.</p>
          <br />

          <h3 class="privacySubTitle">1. DEFINITIONS AND CONSTRUCTION</h3>
          <p class="privacyText">- “Terms Of Use” hereinafter referred to as the "AGREEMENT",
            “ADCROPPER YAYINCILIK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ”, hereinafter referred to as the "COMPANY”
          </p>
          <p class="privacyText">- The digital product, which is the main element of this AGREEMENT, the COMPANY will
            hereinafter be referred to as “PRODUCT”</p>
          <p class="privacyText">- The website [platform.adcropper.com], hereinafter referred to as the "PORTAL",</p>
          <p class="privacyText">- The natural or legal persons who accept the terms by becoming MEMBERS of the PORTAL and
            benefit from the SERVICES and information by purchasing PRODUCT will hereinafter be referred to as “MEMBER”,
          </p>
          <p class="privacyText">- The page accessible with the username and password set by the MEMBER, where they can
            perform the necessary procedures to benefit from all kinds of SERVICES and applications on the PORTAL, enter
            their personal information and other information requested by the PORTAL, which they declare to be true,
            hereinafter referred to as the "MEMBERSHIP ACCOUNT/MY ACCOUNT",</p>
          <p class="privacyText">- Any information, document, file, image, attachment, video, etc., as well as any visual,
            written, and audio content published and accessible on the PORTAL, is referred to as the “CONTENT”,</p>
          <p class="privacyText">- The applications provided by COMPANY to enable the MEMBERS to perform the SERVICES and
            applications defined in the AGREEMENT, hereinafter referred to as "SERVICE",</p>
          <p class="privacyText">- The natural or legal persons who provide or operate the systems hosting the SERVICES
            and the CONTENT, hereinafter referred to as "HOSTING PROVIDER",</p>
          <p class="privacyText">- The natural or legal persons who provide the electronic commerce environment that
            enables the economic and commercial activities of others, hereinafter referred to as "INTERMEDIARY SERVICE
            PROVIDER",</p>
          <p class="privacyText">- The natural or legal persons who access the PORTAL even without being a MEMBER,
            hereinafter referred to as "USER",</p>
          <p class="privacyText">- COMPANY and the MEMBER may sometimes be referred to as "PARTY" or collectively as
            "PARTIES" in this AGREEMENT,</p>
          <p class="privacyText">- “The General Data Protection Regulation” hereinafter referred to as the “GDPR”,</p>
          <p class="privacyText">- “Convention for the Protection of Individuals with regard to Automatic Processing of
            Personal Data” hereinafter referred to as the “Convention 108”,</p>
          <p class="privacyText">- “Organisation for Economic Co-operation and Development” hereinafter reffered to as the
            “OECD”.</p>
          <br />

          <h3 class="privacySubTitle">2. SUBJECT AND SCOPE OF THE AGREEMENT</h3>
          <ol class="privacySubList">
            <li>THE LIMITS OF THE AGREEMENT

              <p class="privacyText">This AGREEMENT is based on the rights and obligations of the PARTIES, and clarifies
                the terms and the scope of the SERVICES to be provided by COMPANY to MEMBER in relation to PRODUCT.</p>
              <p class="privacyText">Within the scope of the AGREEMENT, the COMPANY guarantees to develop the content of
                the PRODUCT in accordance with the customer's requests and usage analyses. Similarly, customization is
                also one of the SERVICES offered. By purchasing PRODUCT, you can create a unique and original
                advertisement customized to your requests.</p>
              <p class="privacyText">Under this AGREEMENT, the COMPANY guarantees that PRODUCT is fully operational. If
                you experience any issues with the PRODUCT'S functionality, you can immediately seek support using the
                contact information provided in Article 10 of this AGREEMENT.</p>
            </li>

            <li>ACCEPTANCE OF TERMS

              <p class="privacyText">The subject and scope of this AGREEMENT involve determining the terms and conditions
                between the PARTIES, as well as establishing the rights and obligations of the PARTIES. By accepting this
                AGREEMENT, the MEMBER acknowledges that they have read and understood the provisions and agrees, declares,
                and undertakes to comply with the PORTAL’S terms and conditions of use.</p>
            </li>
          </ol>
          <br />

          <h3 class="privacySubTitle">3. ACCOUNT REGISTRATION AND LIABILITIES</h3>
          <ol class="privacySubList">
            <li>AGE AND ELIGIBILITY REQUIREMENTS
              <p class="privacyText">The minimum age for using this PRODUCT is 18. Individuals under the age of 18 but
                over the age of 16 may only use this PRODUCT with legal parental consent in accordance with GDPR. As our
                COMPANY adheres to the United Nations Convention on the Rights of the Child, we emphasize the rights and
                safety of children.</p>
              <p class="privacyText">To be more clear, individuals under the age of 16 are not permitted to use our
                PRODUCT under any circumstances.</p>
              <p class="privacyText">Any signatory of this AGREEMENT acknowledges that they possess the legal capacity to
                be a PARTY to a contract. Individuals using the PRODUCT must have the competence to understand the legal
                obligations and responsibilities associated with its use.</p>
            </li>

            <li>USER RESPONSIBILITIES
              <p class="privacyText">The highest attention must be paid to this section. We will list what you can and
                cannot do, and by signing this AGREEMENT, you agree and commit to complying with all these rules.</p>

              <h3 class="privacySubTitle">What You Can Do:</h3>
              <ul class="privacySubList">
                <li>You will receive the full SERVICE provided under this AGREEMENT as long as your payment is up to date.
                  We encourage all feedback and constructive criticism that could help us improve our PRODUCT. By
                  purchasing this PRODUCT, you will have access to all features listed in Article 5 of this AGREEMENT.
                </li>
              </ul>

              <h3 class="privacySubTitle">What You Cannot Do:</h3>
              <ul class="privacySubList">
                <li>
                  You may not use PRODUCT for any illegal activities.
                </li>
                <li>
                  Copying, modifying, selling or renting any of our SERVICES is prohibited.
                </li>
                <li>
                  PRODUCT is built on artificial intelligence coding. You cannot market the content you create with our
                  PRODUCT as if it was produced by a human.
                </li>
                <li>
                  You may not use PRODUCT to make negative propaganda about our SERVICES. If you are not satisfied with
                  the PRODUCT, you may terminate your MEMBERSHIP.
                </li>
              </ul>
            </li>

            <li>REGISTRATION REQUIREMENTS

              <p class="privacyText">
                When creating a MEMBERSHIP on our PORTAL to use our PRODUCT, you are required to provide accurate and
                complete information. For individuals, your information must match what is listed on your identification.
              </p>
              <p class="privacyText">
                For legal entities, the account creation process operates as follows: Our COMPANY initially creates
                accounts for agencies. These agencies can then create accounts for the companies and brands they work with
                to carry out their activities. To create an account for a legal entity, it is necessary to fully provide
                the tax identification number and the relevant details of the authorized persons.
              </p>
              <p class="privacyText">
                it is prohibited to share your account credentials. You are the only one permitted to use your account,
                and you are responsible for all actions taken under your account.
              </p>
            </li>

            <li>CONSEQUENCES OF UNAUTHORIZED USE OF ACCOUNTS

              <p class="privacyText">
                MEMBERS are responsible for maintaining the confidentiality of all account information, including
                usernames, passwords, and other authentication methods shared with our COMPANY when registering. Failure
                to fulfill this responsibility and the theft of your account information require immediate notification to
                us in the event of unauthorized use of your account.
              </p>
              <p class="privacyText">
                The COMPANY reserves the right to suspend or terminate any account that has been accessed without
                authorization in order to protect MEMBERS, the SERVICE, and the other MEMBERS/USERS. Additionally, the
                COMPANY may temporarily or permanently restrict access to the PRODUCT if unauthorized use is detected.
              </p>
              <p class="privacyText">
                The COMPANY reserves the right to claim compensation for any damages caused by unauthorized use of the
                account, whether by the MEMBER or third parties.
              </p>
              <p class="privacyText">
                The COMPANY has the responsibility to take security measures to protect the MEMBER’S account and prevent
                unauthorized access. However, if MEMBERS fail to promptly report unauthorized use, the COMPANY cannot be
                held liable for any resulting damages.
              </p>
              <p class="privacyText">
                If the unauthorized access is conducted with malicious intent, the third parties may face legal and
                criminal penalties. The COMPANY reserves the right to take legal action against any PARTY who engages in
                or aids unauthorized use of accounts.
              </p>
              <p class="privacyText">
                After unauthorized use has been detected and verified, the COMPANY must restore MEMBERS' access to their
                accounts in a secure manner. This may include resetting credentials and implementing additional security
                measures such as multi-factor authentication to prevent future unauthorized access.
              </p>
            </li>
          </ol>
          <br />

          <h3 class="privacySubTitle">4. DIGITAL PRODUCT DESCRIPTIONS AND ATTAINABILITY</h3>
          <p class="privacyText">First of all, we are extremely pleased to have created this PRODUCT for you, our valued
            customers! With our PRODUCT, you can now create advertising campaigns for your businesses even if you don't
            know how to code.</p>
          <ol class="privacySubList">
            <li><b>DETAILS AND IDENTIFICATION OF THE DIGITAL PRODUCT ON THE PORTAL</b></li>
          </ol>
          <h3 class="privacySubTitle centered">• WHAT TYPES OF ADS CAN YOU CREATE WITH OUR PRODUCT?</h3>
          <p class="privacyText">Our PRODUCT is completely dynamic and will automatically create the design you want. The
            types of ads that our PRODUCT can generate are as follows:</p>
          <ul class="privacySubList">
            <li>What is an Image Ad?

              <p class="privacyText">An image ad is typically a type of advertisement that consists of a static image or
                graphic design. This type of ad does not contain video or animation and is not dynamic. The purpose of
                this ad type is to deliver the brand's message strikingly and attractively, and it is displayed on
                websites, social media platforms, and mobile applications.</p>
            </li>
            <li>What is a Video Ad?

              <p class="privacyText">Video ads are advertisements presented in video format on digital platforms. These
                ads are typically shown on websites like YouTube or on social media platforms. Video ads aim to reach
                customers with visual and auditory elements in a limited time frame, usually within 15-30 seconds.</p>
            </li>
            <li>What is a Banner Ad?

              <p class="privacyText">Banner ads are visual or text-based advertisements that appear at the top, sides or
                center of a website. These ads can be either static or dynamic.</p>
            </li>
            <li>What is an HDMI Dynamic Ad?

              <p class="privacyText">HDMI dynamic ads are typically used on digital screens in places such as retail
                stores, shopping malls, hotels, restaurants or public places. This system allows advertisers to project
                content onto a screen via HDMI connection and continuously broadcast dynamic, live, and updatable ads.</p>
              <p class="privacyText">With PRODUCT, you will be able to create all these types of ads and promote your
                brand perfectly.</p>
            </li>
          </ul>
          <br />

          <h3 class="privacySubTitle centered">• HOW CAN YOU SHARE ADS CREATED IN OUR PRODUCT?</h3>
          <p class="privacyText">Additionally, we offer the following sharing options within our PRODUCT:</p>
          <p class="privacyText">- <b>Export:</b> You can export the ads you create with our PRODUCT in PDF, JPEG, PNG, or
            other formats.</p>
          <p class="privacyText">- <b>Gift:</b> With this option, you can send the ads you create as a gift. Please note
            that when you gift an ad to another user, you are also transferring the usage rights of the ad to that person.
          </p>
          <p class="privacyText">- <b>Publish:</b> You will have the ability to publicly share the ads you create with
            this option.</p>
          <br />

          <p class="privacyText">Also, with the "Display" option, you can access settings related to how your ad will be
            displayed. For example, you can adjust the resolution and size of your ad, its appearance on different
            devices, the theme and color scheme, and choose between portrait or landscape mode for display. This way, the
            outputs of our PRODUCT are shaped by your USER experience and offer customization options.</p>
          <ul class="privacySubList">
            <li><b>WHAT IS GOOGLE CAMPAIGN MANAGER AND WHAT OPPORTUNITIES DOES INTEGRATION PROVIDE?</b></li>
          </ul>

          <p class="privacyText">
            Google Campaign Manager is a platform used to manage, analyze, and optimize digital ad campaigns. Since our
            PRODUCT is directly integrated with Google Campaign Manager, you will be able to monitor ad management, ad
            serving, and performance analysis.
          </p>
          <p class="privacyText">
            With Google Campaign Manager integration, you can track metrics such as ad impressions, click-through rates,
            and conversion rates. This integration guides you in ensuring that your ads reach the right audience at the
            right time. Through analysis, Google Campaign Manager provides you with meaningful and comprehensive
            reporting, helping you create meaningful goals to make your ads reach a wider audience more effectively.
          </p>
          <p class="privacyText">
            With Cross-Device tracking, you can monitor the interactions of USERS who are interested in your ad across
            different devices and evaluate how a campaign performs on various devices. This feature allows you to offer
            USERS a consistent ad experience.
          </p>
          <p class="privacyText">
            In addition, Google Campaign Manager uses a tracking technology called Floodlight to monitor ad conversions.
            Floodlight tracks whether a USER interacts with an ad and whether this interaction results in a conversion
            (such as a purchase, form submission, etc.).
          </p>
          <p class="privacyText">
            Google Campaign Manager can work in integration with other Google products (Google Analytics, Google Ads) and
            third-party ad platforms. These integrations make it easy to share your data and manage your campaigns in a
            multifaceted way.
          </p>

          <ul class="privacySubList">
            <li><b>WHAT OPPORTUNITIES DOES OUR PRODUCT'S GMAIL INTEGRATION PROVIDE?</b></li>
          </ul>

          <p class="privacyText">
            With this integration, you will be able to access your Gmail accounts while using our PRODUCT and send/receive
            emails. Additionally, during the use of the PRODUCT, you can track and manage event calendars related to your
            ads through Google Calendar.
          </p>
          <p class="privacyText">
            Gmail integration is synchronized with Google Contacts, allowing you to manage email addresses and personal
            information. This way, you can quickly access contact lists through the PRODUCT.
          </p>
          <p class="privacyText">
            Also, you can share or receive large files through Google Drive integration. Through the integration, you will
            receive notifications within the PRODUCT regarding incoming email alerts. This ensures that you do not miss
            important messages.
          </p>
          <p class="privacyText">
            Additionally, any changes we make to the PRODUCT will be sent to you directly via email through Gmail
            integration. Continuing to use the SERVICE after the email is sent indicates your acceptance of the changes.
          </p>
          <p class="privacyText">
            Lastly, you can securely log into our PORTAL using your Gmail account through Google's OAuth authorization
            system. Not having to create an additional account does not exempt you from signing this AGREEMENT. By
            creating an account through Gmail integration, you will also be agreeing to this AGREEMENT and any other
            related terms and conditions.
          </p>
          <p class="privacyText">
            You can always reach out to us for help with using the PRODUCT. We are continuously working to ensure the
            functionality and security of our PRODUCT, and we will always be proactive in resolving any issues you may
            encounter.
          </p>

          <ol class="privacySubList">
            <li><b>LICENSE AND USE OF PRODUCTS</b></li>
          </ol>
          <h3 class="privacySubTitle centered">• THE TYPE OF LICENSE GRANTED TO USERS</h3>

          <p class="privacyText">
            In accordance with this AGREEMENT, any individual or entity that registers as a MEMBER and purchases the
            PRODUCT will be considered a licensee and will thereby receive the rights and assume the obligations
            associated with the license.
          </p>
          <p class="privacyText">
            The licensee is hereby granted a non-exclusive, non-transferable license to use the PRODUCT or software
            strictly in accordance with the purposes set forth in this AGREEMENT. This license is non-transferable,
            meaning that the licensee is prohibited from assigning, leasing, sublicensing, selling or otherwise
            transferring the license or any rights conferred by this AGREEMENT to any third party or legal entity, in
            whole or in part.
          </p>
          <p class="privacyText">
            The licensee is expressly authorized to use the PRODUCT solely for their internal business purposes, and this
            license is strictly limited to the licensee. The licensee shall not share, distribute or transfer the PRODUCT
            or software to any other individual or entity without the prior written consent of the licensor.
          </p>
          <p class="privacyText">
            Any transfer, assignment or sublicensing of this license or any portion of the licensed PRODUCT, without the
            prior written consent of the licensor, shall constitute a material breach of this AGREEMENT. Upon such a
            breach, the licensor reserves the right to immediately terminate the license and pursue any and all legal
            remedies available under applicable law.
          </p>
          <p class="privacyText">
            Furthermore, any attempt by the licensee to transfer or sublicense the license, whether through operation of
            law or any other means, shall be deemed a violation of this AGREEMENT. The licensor reserves the right to seek
            injunctive relief, damages or any other legal remedies necessary to protect its rights. The licensee agrees to
            indemnify, defend, and hold the licensor harmless against any claims, losses, or damages resulting from
            unauthorized use, transfer or sublicensing of the licensed PRODUCT.
          </p>
          <p class="privacyText">
            This license is valid for use in countries governed by the General Data Protection Regulation (GDPR),
            including but not limited to all member states of the European Union (EU) and countries within the European
            Economic Area (EEA). The licensee agrees to fully comply with all GDPR requirements regarding the collection,
            processing, and storage of personal data, as well as any other applicable data protection and privacy
            regulations.
          </p>
          <p class="privacyText">
            The licensee acknowledges that the PRODUCT will be used in strict compliance with GDPR within these
            jurisdictions. The licensee further agrees to ensure that all data processing activities, including the
            handling and management of personal data, are conducted in adherence to GDPR standards.
          </p>
          <p class="privacyText">
            In the event of any breach of GDPR compliance, the licensee shall bear full responsibility for any claims,
            damages, penalties or liabilities arising from such non-compliance. The licensor shall not be held liable for
            any breaches of GDPR by the licensee.
          </p>
          <p class="privacyText">
            Upon termination of this license, whether due to a breach or otherwise, the licensee agrees to immediately
            cease all use of the PRODUCT and to destroy or return all copies of the licensed software, documentation, and
            any associated materials, including backups or derivative works, in their possession. Failure to comply with
            this requirement may subject the licensee to legal action for damages.
          </p>
          <p class="privacyText">
            The licensee is expressly authorized to use the features and functionalities of the current version of the
            PRODUCT or software, as specified in this AGREEMENT. The license period is determined by the type of
            MEMBERSHIP selected, with monthly MEMBERSHIPS granting a license for a one-month term, automatically renewing
            unless canceled, and annual MEMBERSHIPS granting a license for a one-year term, subject to renewal.
          </p>
          <p class="privacyText">
            The licensee may create backup copies of the PRODUCT solely for archival purposes, provided that such copies
            retain all original copyright notices and other proprietary rights markings. These backup copies may not be
            used for any purpose other than restoration of the original software in case of system failure.
          </p>

          <h3 class="privacySubTitle centered">• RESTRICTIONS ON USE</h3>
          <p class="privacyText">
            USERS AND MEMBERS are not authorized to copy, reproduce, modify, distribute or transfer our PRODUCT to third parties. Our PRODUCT can only be used by the MEMBERS to whom we have granted a license.
          </p>
          <p class="privacyText">
            The COMPANY’s developers and other components have invested significant time and effort into creating our PRODUCT. Therefore, analyzing how our PRODUCT works, reverse-engineering its code structure or disassembling its components is prohibited. This is referred to as the "prohibition of reverse engineering” and all our MEMBERS must comply with this rule. By protecting this prohibition of reverse engineering in this AGREEMENT, we aim to safeguard all the intellectual property rights of our COMPANY and prevent the misuse of our PRODUCT.
          </p>
          <p class="privacyText">
            Additionally, it is important to note that any data obtained through reverse engineering is unlawful. If we determine that your data has been accessed by malicious individuals through reverse engineering, we will notify you accordingly and take the necessary security measures in fulfillment of our responsibilities.
          </p>
          <p class="privacyText">
            Furthermore, “the prohibition of creating derivative works” means that it is prohibited to modify, adapt or alter our PRODUCT without the permission of our COMPANY that owns the license. For example, any versions derived from our PRODUCT that have been modified, supplemented with new functions or adapted will violate our COMPANY's intellectual property rights.
          </p>
          <p class="privacyText">
            The license for our PRODUCT allows it to be used only under specific conditions. Creating a new product by modifying it violates these licensing terms. It is prohibited for our MEMBERS to sell, lease or license the digital product to another person.
          </p>

          <h3 class="privacySubTitle centered">• TERMINATION OF THE LICENSE IN CASE OF VIOLATION</h3>

          <p class="privacyText">The following actions are considered violations of the license:</p>
          <p class="privacyText" style={{marginLeft:"20px;"}}>
            - Unauthorized copying and distribution,<br />
            - Making unauthorized changes to our PRODUCT and creating derivative works,<br />
            - Performing reverse engineering,<br />
            - Transferring or sharing our PRODUCT with third parties,<br />
            - Non-payment of licensing fees.<br />
          </p>
          <br />
          <p class="privacyText">In the event of a violation of the license as outlined above:</p>
          <p class="privacyText" style={{marginLeft:"20px;"}}>
            - We will notify you of the violation and allow for fifteen (15) days to rectify the situation,<br />
            - If the violation is not resolved within this period, we will terminate your license via an email notification. Once the license is terminated, you will no longer have access to the PRODUCT.<br />
            - Upon the termination of the license, all copies of our PRODUCT must be destroyed.<br />
            - If you fail to destroy the copies after the license is terminated, you will be held responsible for any legal and criminal liabilities that may arise.<br />
          </p>

          <h3 class="privacySubTitle">5. INTELLECTUAL AND INDUSTRIAL PROPERTY RIGHTS</h3>
          <p class="privacyText">
            All intellectual property rights related to our PRODUCT, including but not limited to copyrights, patents, trademarks, trade secrets and designs, are solely and exclusively owned by our COMPANY and its licensors.
          </p>
          <p class="privacyText">
            Under the license terms outlined in Article 5 of this AGREEMENT, you are granted a limited, non-exclusive, non-transferable, and revocable license to use the PRODUCT. This license only allows our MEMBERS to use the PRODUCT for personal or commercial purposes under specific conditions, and it does not imply any transfer of ownership rights over the PRODUCT. All patents, trademarks, and trade secrets related to our PRODUCT are also covered under our intellectual property rights.
          </p>
          <p class="privacyText">
            MEMBERS acknowledge that, under this clause of the AGREEMENT, they have only obtained a license to use the PRODUCT. This license does not grant any ownership rights or transferable rights over the PRODUCT or any intellectual property related to it.
          </p>
          <p class="privacyText">MEMBERS agree to:</p>
          <p class="privacyText" style={{marginLeft:"20px;"}}>
            - Not modify, adapt, translate, reverse engineer, decompile, disassemble or create derivative works based on the PRODUCT,
            - Not remove or alter any copyright, trademark or other proprietary notices contained in the PRODUCT,
            - Not use the PRODUCT in a way that infringes on the intellectual property rights of our COMPANY or third parties.
          </p>

          <p class="privacyText">
            Regarding Industrial Property Rights; all industrial property rights, such as patents or industrial designs related to the technology underlying the PRODUCT, are exclusively owned by our COMPANY. MEMBERS cannot claim ownership or rights over these and cannot use them without our written consent.
          </p>
          <br />
          <p class="privacyText">
            MEMBERS are obliged to notify us immediately in case of any infringement of the intellectual or industrial property rights related to the PRODUCT by third parties. If MEMBERS infringe upon the rights of third parties by using our PRODUCT, they are solely responsible for the consequences of such infringements.
          </p>
          <br />
          <p class="privacyText">
            Our COMPANY reserves the right to initiate legal or criminal proceedings in case of intellectual or industrial property rights violations. Any damages resulting from such infringements are the sole responsibility of our MEMBERS.
          </p>
          <br />
          <p class="privacyText">
            In cases where the PRODUCT contains third-party intellectual property rights, MEMBERS agree to comply with the terms of the relevant third-party licenses. Our COMPANY cannot be held liable for any infringement of third-party intellectual property rights by the MEMBER.
          </p>
          <br />
          <p class="privacyText">
            MEMBERS agree to indemnify and hold our COMPANY harmless from any claims, damages, losses or expenses arising from violations of intellectual or industrial property rights.
          </p>
          <br />
          <p class="privacyText">
            In the event of the termination of this AGREEMENT for any reason, the license granted to the MEMBER will automatically terminate, and the Customer must immediately cease using the PRODUCT and all intellectual or industrial property rights related to it.
          </p>
          <br />
          <p class="privacyText">
            All rights not expressly granted to the MEMBER under this AGREEMENT are reserved by the PROVIDER.
          </p>
          <br />

          <h3 class="privacySubTitle">6. OBLIGATION TO INFORM ABOUT SOFTWARE AND PLUGINS</h3>
          <p class="privacyText">
            We may require additional software and plugins to enhance the development of our PRODUCT. Such software or plugins may improve the performance, ensure compatibility or add new features to our PRODUCT.
          </p>
          <br />
          <p class="privacyText">
            To facilitate the marketing of our PRODUCT, we may integrate it with various platforms. Information regarding these integrations has been provided in Article 5 of this AGREEMENT.
          </p>
          <br />
          <p class="privacyText">
            If we require software or plugins beyond the SERVICES defined in this AGREEMENT, we commit to providing our MEMBERS with clear information.
          </p>
          <br />
          <p class="privacyText">
            If additional software or plugins are needed for our digital product, it is solely to make the PRODUCT more functional.
          </p>
          <br />
          <p class="privacyText">
            In the event that issues arise with third-party software or plugins under this AGREEMENT, our responsibility will be limited. The primary responsibility lies with the third party.
          </p>
          <br />

          <h3 class="privacySubTitle">7. TERMINATION OF SERVICES</h3>
          <p class="privacyText">Our MEMBERs can terminate the PRODUCT SERVICE you purchased from our PORTAL at any time for any reason. To terminate the SERVICE, simply cancel your MEMBERSHIP via the PORTAL.  </p>
          <p class="privacyText">Our COMPANY, however, reserves the right to terminate the SERVICE, with or without prior notice, in the following situations:</p>
          <p class="privacyText">
            - The MEMBERS violate the provisions of this AGREEMENT,<br />
            - The PRODUCT is used in an illegal or inappropriate manner,<br />
            - The MEMBERS fail to make payments or fulfill their financial obligations,<br />
          </p>
          <p class="privacyText">
            Termination is required due to legal obligations or official requests.
          </p>
          <p class="privacyText">
            In addition, our COMPANY reserves the right to immediately terminate the SERVICE without prior notice in the event of any security threat, fraud detection or other critical circumstances.
          </p>
          <p class="privacyText">
            In such emergency terminations, your access to the PRODUCT and SERVICE will be immediately suspended. All data and content belonging to the MEMBERS may be deleted or deactivated in accordance with the applicable privacy policy and data retention procedures.
          </p>
          <p class="privacyText">
            In the case of such emergency terminations, no refunds will be provided for SERVICES rendered up to the date of termination.
          </p>
          <p class="privacyText">
            Even after the SERVICE has been terminated, the indemnity, limitation of liability, and confidentiality provisions of this AGREEMENT will remain in effect. MEMBERS may still be liable for any unauthorized use of the PRODUCT.
          </p>
          <p class="privacyText">
            Our COMPANY reserves the right to temporarily suspend SERVICES due to technical maintenance, updates, or system improvements. In such cases, MEMBERS will be notified in advance, and the SERVICE will be restored as soon as possible.
          </p>

          <h3 class="privacySubTitle">8. LIMITATION OF LIABILITY</h3>
          <p class="privacyText">
            As a COMPANY, we have designed a PRODUCT to help you create advertisements more easily. Please be aware that we provide our PRODUCT "as is". It would be a mistake to expect anything beyond the scope of the SERVICES we have expressly defined.
          </p>
          <p class="privacyText">
            We do not accept any responsibility for direct or indirect damages, losses, data loss, business interruptions, loss of profits, or other intangible damages that may arise from the use of our PRODUCTS.
          </p>
          <br />

          <p class="privacyText">
            Our COMPANY’s liability is limited to direct damages only. However, this liability is also capped by the amount you have paid for the SERVICES provided during the period in which the damage occurred. Under no circumstances will our COMPANY be held liable for any punitive or special damages exceeding this amount.
          </p>
          <p class="privacyText">
            Our COMPANY does not accept responsibility for any data loss, security breaches, business interruptions or other technical issues that may occur during the use of our PRODUCTS.
          </p>
          <br />

          <p class="privacyText">
            In marketing our PRODUCT through the PORTAL, we must collaborate with some third parties. We strive to work with the most reliable platforms for these collaborations. However, our COMPANY cannot be held liable for risks associated with the use of SERVICES provided by third parties.
          </p>
          <br />
          <p class="privacyText">
            Our COMPANY cannot limit its liability in cases of fraud, willful misrepresentation or negligence resulting in death or personal injury. In such cases, liability will be governed by applicable laws.
          </p>

          <h3 class="privacySubTitle">9. INDEMNIFICATION</h3>
          <p class="privacyText">Your responsibility as a MEMBER begins as soon as you purchase and start using our PRODUCT. If you use our PRODUCT in an unlawful manner or against the interests of a third party, all legal and criminal liability will rest entirely with you. These responsibilities include, but are not limited to, court fees, expenses, and attorney's fees. </p>
          <p class="privacyText">Additionally, in the following situations, you as a MEMBER will be liable to indemnify our COMPANY:</p>
          <p class="privacyText">
            - The incorrect, inappropriate, or unlawful use of the output from our PRODUCT,<br />
            - Violation of the provisions of this AGREEMENT,<br />
            - Infringement of third-party intellectual property rights or other legal rights,<br />
            - Engaging in illegal activities or fraudulent acts,<br />
            - Unauthorized sharing or distribution of PRODUCTS.<br />
          </p>
          <br />
          <p class="privacyText">
            Our COMPANY reserves the right to assert any claims or defenses related to any lawsuit or legal proceedings that may arise concerning indemnification. We also expect your cooperation in any legal processes related to indemnification. This cooperation may include providing necessary documents and active support in legal proceedings.
          </p>
          <p class="privacyText">
            If our COMPANY is involved in intentional acts, fraud or gross negligence, MEMBERS may be exempt from indemnification obligations. In such cases, the applicable legal regulations will apply.
          </p>

          <h3 class="privacySubTitle">10. CONTACT INFORMATION</h3>
          <p class="privacyText">For any questions, concerns, or support related to this AGREEMENT, please contact us using the <Link to={"/book-demo"}>contact.</Link></p>

          <h3 class="privacySubTitle">11. MISCELLANEOUS</h3>
          <ol class="privacySubList">
            <li>ENTIRE AGREEMENT

              <p class="privacyText">This AGREEMENT and any other agreements referenced within this AGREEMENT are the only binding agreements between the PARTIES. No other understandings or agreements shall be binding between the PARTIES. The certainty of the agreement is guaranteed by this clause. The PARTIES acknowledge that this AGREEMENT is valid only if it has been signed and approved by authorized persons.</p>
            </li>

            <li>SEVERABILITY

              <p class="privacyText">
                If any provision of this AGREEMENT is declared invalid, void or unenforceable by a court decision or a competent legal authority, only that provision shall be considered invalid. The remaining provisions of the AGREMEENT shall remain fully valid and in force.
              </p>
              <p class="privacyText">
                In the event a provision is deemed invalid, if it is possible to modify the provision in a manner that best reflects the PARTIES’ intentions and is compliant with the law, the PARTIES will cooperate to make that provision legally valid. However, this modification must be in accordance with the spirit of the AGREMENT and must not disrupt its balance.
              </p>
              <p class="privacyText">
                With this clause, the PARTIES agree that if any provision of this AGREEMENT is invalidated, that provision shall be removed from the AGREEMENT, and such removal shall not affect the remainder of the AGREEMENT.
              </p>
            </li>

            <li>AMENDMENTS

              <p class="privacyText">
                We may update or improve our PRODUCT based on your feedback or if deemed necessary by our COMPANY. In addition to updates, changes to the AGREEMENT may also be made due to mandatory legal changes, security reasons, and adapting to new technologies.
              </p>
              <p class="privacyText">
                If these changes negatively affect the general terms of the AGREEMENT or the rights and obligations of the PARTIES, we will seek your approval. We will notify you of changes to these terms at least 30 days in advance via the email address you provided when registering on our site or through in-app notifications. If you do not accept the changes, you have the right to terminate your MEMBERSHIP.
              </p>
              <p class="privacyText">
                Any amendment to a specific clause of the AGREEMENT will be limited to that clause and will not affect the AGREEMENT as a whole.
              </p>
              <p class="privacyText">
                Due to the nature of our PRODUCT, it is possible for changes mutually agreed upon between the PARTIES to be signed and approved in a digital environment. This approval may be executed through an electronic signature and shall be legally binding.
              </p>
            </li>

            <li>FORCE MAJEURE

              <p class="privacyText">
                Force majeure in law refers to an event, circumstance, or condition that, due to its nature, prevents the fulfillment of a responsibility, the exercise of a right or legal possibility, or the use or demand of a provision, either partially or fully, temporarily or permanently. It thus eliminates liability or delays the fulfillment, timing, and due date of a responsibility, or changes the nature of the liability, which may necessitating the granting or extension of periods or reinstatement of rights, legal possibilities or provisions. Such events are of a nature that the individual could not foresee or anticipate in advance, and even if they were anticipated, they are events that could not have been prevented by any measures a person could have taken. These events are extraordinary, external, exceptional, and beyond the routine and continuous circumstances.
              </p>
              <p class="privacyText">
                These events include, but are not limited to, natural disasters (earthquakes, floods, fires, etc.), wars, rebellions, terrorist acts, extraordinary government decisions, legal regulations, pandemics, infrastructure issues, cyberattacks, and other similar extraordinary circumstances.
              </p>
              <p class="privacyText">
                If a force majeure event occurs and prevents one of the PARTIES from fulfilling its obligations under the contract, that PARTY will be exempt from liability. Until the force majeure event ceases, the obligations of the affected PARTY shall be suspended.
              </p>
              <p class="privacyText">
                If our COMPANY is affected by a force majeure event, we will immediately notify our MEMBERS of the nature of the event and its potential impact.
              </p>
              <p class="privacyText">
                If the force majeure event persists for 90 days, either PARTY has the right to terminate the contract. In such cases, neither PARTY shall have any claims for refunds or compensation for SERVICES rendered or payments made.
              </p>
              <p class="privacyText">
                Once the force majeure event concludes, the suspended obligations shall be resumed within a reasonable period. Both PARTIES shall make good-faith efforts to fulfill the affected SERVICES during the force majeure period.
              </p>
              <p class="privacyText">
                Events such as cyberattacks, internet outages, national or international technical failures, and other extraordinary circumstances related to digital infrastructure that may affect the digital SERVICES provided by our COMPANY shall also be considered force majeure. In such cases, our COMPANY cannot be held responsible for SERVICE disruptions.
              </p>
            </li>

            <li>NOTICES

              <p class="privacyText">This clause establishes the procedures for how the PARTIES will communicate with each other. It clarifies how official communication will be conducted. The communication methods determined by our COMPANY are as follows:</p>
              <p class="privacyText">
                • Email sent to the email address you provided when creating your accounts,<br />
                • Other electronic communication platforms mutually agreed upon. <br />
              </p>
              <p class="privacyText">
                Additionally, if you wish to contact us, you can use the information provided in Article 10 of this AGREEMENT.
              </p>
              <p class="privacyText">
                An email we send to you will be deemed delivered 24 hours after we receive a confirmation of receipt.
              </p>
              <p class="privacyText">
                Both PARTIES to this AGREEMENT are obligated to promptly notify the other PARTY if their contact information changes. Failure to update contact information does not exempt the PARTY from its obligations under this AGREEMENT.
              </p>
              <p class="privacyText">
                If our COMPANY makes any changes to this AGREEMENT or our PRODUCT, we will notify you via your registered email address or through in-app notifications. Your continued use of the PRODUCT will be considered acceptance of the changes.
              </p>
              <p class="privacyText">
                All notices and communications between the PARTIES will be conducted in English, and any communication provided in another language will only be valid if accompanied by an official translation.
              </p>
              <p class="privacyText">
                The PARTIES agree that notices may be delivered electronically and that such electronic notices will have the same legal effect as written communication.
              </p>
            </li>

            <li>WAIVER

              <p class="privacyText">
                The failure or delay of either PARTY to exercise any right, power or privilege under this AGREEMENT shall not be construed as a waiver of such rights. If either PARTY partially exercises any right, it does not preclude the PARTY from exercising its other rights.
              </p>
              <p class="privacyText">
                Any waiver of a right or obligation under this AGREEMENT shall apply only to the specific instance for which the waiver is granted and shall not be interpreted as a continuing waiver of any other rights or obligations. It also shall not apply to future situations or violations.
              </p>
              <p class="privacyText">
                Any waiver granted under this AGREEMENT does not affect the remaining rights, remedies or rivileges under the AGREEMENT, all of which shall remain fully in force.
              </p>
            </li>

            <li>HEADINGS

              <p class="privacyText">
                The headings in this AGREEMENT are written to facilitate your reading. The headings do not affect or limit the meaning, interpretation, or scope of any provision of this AGREEMENT. The PARTIES acknowledge that the headings are not part of the binding provisions of the AGREEMENT.
              </p>
              <p class="privacyText">
                It is not intended for any heading to be used in a way that narrows or broadens the scope of the relevant provision. These headings do not affect the main provisions that determine the rights and obligations of the PARTIES.
              </p>
            </li>
          </ol>

          <h3 class="privacySubTitle">12. DISPUTE RESOLUTON</h3>
          <p class="privacyText">First and foremost, we would like to state that in the event of any dispute arising from this AGREEMENT or any supplementary agreements, we wish to resolve it through peaceful negotiations.</p>

          <ol class="privacySubList">
            <li>METHODS OF RESOLVING DISPUTES

              <p class="privacyText">
                With this clause of the AGREEMENT, we find it appropriate to apply the following negotiation methods in the event of any dispute arising from this AGREEMENT or any supplementary agreements between the PARTIES. Additionally, if the PARTIES are unable to resolve their dispute within 30 days, they agree to apply the methods listed below in the given order.
              </p>
              <p class="privacyText">
                Mediation: Mediation has emerged in recent years as a peaceful resolution method worldwide. The PARTIES shall jointly select a person authorized for mediation by mutual agreement. In accordance with our COMPANY policies, we ensure cooperation throughout the negotiation process. Unless otherwise agreed, mediation costs will be shared equally between the PARTIES.
              </p>
              <p class="privacyText">
                Arbitration: In the event that mediation is unsuccessful, the dispute shall be resolved through binding arbitration. Any dispute arising from or in connection with this AGREEMENT shall be resolved through binding arbitration under the rules of the London Court of International Arbitration (LCIA). The seat of arbitration shall be London, United Kingdom, and the arbitration proceedings shall be conducted in English. English law shall apply during the arbitration process. The decision of the arbitrator shall be final and binding on the PARTIES. Unless otherwise agreed, arbitration costs will be shared equally between the PARTIES.
              </p>
              <p class="privacyText">
                Litigation: If arbitration is not feasible or enforceable, the PARTIES may bring the dispute before the competent courts specified under the “Governing Law”section.
              </p>
            </li>

            <li>GOVERNING LAW
              <p class="privacyText">
                This AGREEMENT shall be governed by and construed in accordance with Turkish law, without regard to its conflict of law principles.
              </p>
              <p class="privacyText">
                Any legal action or proceeding arising out of or related to this AGREEMENT shall be brought exclusively in the competent courts within the borders of the Republic of Turkey, and the PARTIES irrevocably consent to the personal jurisdiction and venue of such courts.
              </p>
              <p class="privacyText">
                By accepting this AGREEMENT, the PARTIES acknowledge and agree that the governing law will be as specified above, and any disputes shall be resolved within the specified jurisdiction and courts.
              </p>
            </li>
          </ol>
        </div>
      </section>
      <Footer />
    </main>
  )
}

export default Terms
